module.exports = __webpack_public_path__ + "img/btn_eng_stop_on.fd3f3c4c.jpg";